import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/CustomerEmail"));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
export const generate = ()=>crypto.randomUUID();
